import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';

import { VendorsResponseSchema } from '../types/VendorsSchema';

export const fetchAllVendorsList = createAsyncThunk<
    VendorsResponseSchema,
    null,
    ThunkConfig<string>
>('vendors/allListVendors', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<VendorsResponseSchema>(
            `/v1/vendors`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
